import { createRouter, createWebHistory } from 'vue-router';
import ClientsList from '@/pages/monitoring/MonitoringList.vue'; 
import CompaniesList from './pages/companies/CompaniesList.vue';
import CompaniesEdit from './pages/companies/CompaniesEdit.vue';
import PopEdit from './pages/companies/PopEdit.vue';
import ZabbixEdit from './pages/companies/ZabbixEdit.vue';
import SectionEdit from './pages/companies/SectionEdit.vue';
import ResolveList from './pages/resolution/ProblemList.vue';
import PartnerEdit from './pages/companies/PartnerEdit.vue';
import InstructionEdit from './pages/companies/InstructionEdit.vue';
import ProblemView from './pages/resolution/ProblemView.vue';
import SharedPlaybooks from './pages/playbooks/SharedPlaybooks.vue';
import ActionEdit from './pages/playbooks/ActionEdit.vue';
import PlaybookShared from './pages/playbooks/PlaybookShared.vue';
import WhatsappSystemEdit from './pages/companies/WhatsappSystemEdit.vue';
import MicrosoftLogin from './pages/login/MicrosoftLogin.vue';
import UserList from './pages/users/UserList.vue';
import SchedulesList from './pages/schedules/SchedulesList.vue';
import SchedulesEdit from './pages/schedules/SchedulesEdit.vue';

const routes = [
  { path: '/', redirect: '/problemas' },
  { path: '/auth/login', component: MicrosoftLogin},
  { path: '/:groups', component: ClientsList }, 
  { path: '/agendamentos', component: SchedulesList }, 
  { path: '/agendamentos/:id', component: SchedulesEdit },
  { path: '/problemas', component: ResolveList},
  { path: '/usuarios', component: UserList},
  { path: '/playbooks/compartilhados', component: SharedPlaybooks},
  { path: '/acao', component: ActionEdit}, 
  { path: '/playbooks/:id', component: PlaybookShared},  
  { path: '/problemas/:id', component: ProblemView}, 
  { path: '/empresas', component: CompaniesList },
  { path: '/empresas/:id', component: CompaniesEdit },
  { path: '/empresas/site/:id', component: PopEdit },
  { path: '/empresas/zabbix/:id', component: ZabbixEdit },
  { path: '/empresas/trecho/:id', component: SectionEdit },
  { path: '/empresas/parceiro/:id', component: PartnerEdit },
  { path: '/empresas/instrucao/:id', component: InstructionEdit },
  { path: '/empresas/sistema-de-whatsapp/:id', component: WhatsappSystemEdit },
];

const router = createRouter({
  history: createWebHistory(), 
  routes
});

export default router;